export default __webpack_public_path__ + "static/media/CenturyGothicPaneuropeanItalic.863bf466.ttf";